import { Disclosure } from "@headlessui/react";
import ChevronRight from "@material-ui/icons/ChevronRight";
import type { DigitalAsset } from "../types";

interface WebsiteSectionProps {
  asset: DigitalAsset;
}

const WebsiteSection = ({ asset }: WebsiteSectionProps) => (
  <Disclosure defaultOpen>
    {({ open }) => (
      <div className="bg-white rounded-lg box-shadow">
        <Disclosure.Button className="disclosureBtn ml-2">
          <ChevronRight
            className={`${
              open ? "transform rotate-90" : " text-gray-500"
            } text-gray-500 w-5 h-5 `}
          />
          <span className="disclosureLabel ml-2">Website</span>
        </Disclosure.Button>

        <Disclosure.Panel className="text-xs">
          <div className="grid grid-cols-2 text-xs">
            <div className="grid grid-cols-1 py-2 px-4 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">Website:</label>
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="mx-4 expandedData fontExpand text-blue-500 underline break-all"
                href={
                  asset.website__C && asset.website__C !== "NULL"
                    ? asset.website__C
                    : ""
                }
              >
                {asset.website__C && asset.website__C !== "NULL"
                  ? asset.website__C
                  : ""}
              </a>
              <div className="border-b border-gray-200"></div>
            </div>

            <div className="grid grid-cols-1 py-2 px-4 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Website Local Profile URL SPA:
              </label>
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="mx-4 expandedData fontExpand text-blue-500 underline break-all"
                href={
                  asset.website_Local_Profile_Url_Spa__C &&
                  asset.website_Local_Profile_Url_Spa__C !== "NULL"
                    ? asset.website_Local_Profile_Url_Spa__C
                    : ""
                }
              >
                {asset.website_Local_Profile_Url_Spa__C &&
                asset.website_Local_Profile_Url_Spa__C !== "NULL"
                  ? asset.website_Local_Profile_Url_Spa__C
                  : ""}
              </a>
              <div className="border-b border-gray-200"></div>
            </div>

            <div className="grid grid-cols-1 py-2 px-4 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Website Local Profile URL:
              </label>
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="mx-4 expandedData fontExpand text-blue-500 underline break-all whitespace-3"
                href={
                  asset.website_Local_Profile_Url__C &&
                  asset.website_Local_Profile_Url__C !== "NULL"
                    ? asset.website_Local_Profile_Url__C
                    : ""
                }
              >
                {asset.website_Local_Profile_Url__C &&
                asset.website_Local_Profile_Url__C !== "NULL"
                  ? asset.website_Local_Profile_Url__C
                  : ""}
              </a>
              <div className="border-b border-gray-200"></div>
            </div>

            <div className="grid grid-cols-1 py-2 px-4 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Page Description SPA:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {asset.page_Description_Spa__C &&
                asset.page_Description_Spa__C !== "NULL"
                  ? asset.page_Description_Spa__C
                  : ""}
              </div>
            </div>

            <div className="grid grid-cols-1 py-2 px-4 space-y-2">
              <label className="mx-4 expandedLabel fontExpand">
                Page Description:
              </label>
              <div className="mx-4 expandedData fontExpand">
                {asset.page_Description__C &&
                asset.page_Description__C !== "NULL"
                  ? asset.page_Description__C
                  : ""}
              </div>
            </div>
          </div>
        </Disclosure.Panel>
      </div>
    )}
  </Disclosure>
);

export default WebsiteSection;